module.exports = __webpack_public_path__ + "static/media/wedigitek_interno.9b5eb8f9.png";